




























































































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateRole from './create_.vue'
import EditRole from './view.vue'
import columns from "./columns";
   
class PageRequest_ extends PageRequest {
  keyword: string;
  clientCode: string;
}
      
@Component({
    components:{CreateRole,EditRole}
})
export default class Roles extends AbpBase{
  namespace = "warrantyDurationConfig";
  pagerequest: PageRequest_ = new PageRequest_();
  spinShow: boolean = false;
  clients: any = [];
  createModalShow:boolean=false;
  editModalShow:boolean=false;
  viewModalShow:boolean=false;
  code: any = null;

  get list(){
    var re = this.$store.state.warrantyDurationConfig.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  get loading(){
      return this.$store.state.warrantyDurationConfig.loading;
  }

  showModal(value) {
    this.createModalShow = value;
  }

  view(code: string) {
    this.code = code;
    this.viewModalShow = true;
  }
  create(){
    this.code = null;
    this.createModalShow=true;
  }
  update(code: string){
    this.code = code;
    this.createModalShow=true;
  }
  pageChange(page:number){
      this.$store.commit('warrantyDurationConfig/setCurrentPage',page);
      this.getpage();
  }
  pagesizeChange(pagesize:number){
      this.$store.commit('warrantyDurationConfig/setPageSize',pagesize);
      this.getpage();
  }
  async getpage(){
      this.pagerequest.maxResultCount=this.pageSize;
      this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize; 
      await this.$store.dispatch({
          type:'warrantyDurationConfig/getAll',
          data:this.pagerequest
      })
  }
  get pageSize(){
      return this.$store.state.warrantyDurationConfig.pageSize;
  }
  get totalCount(){
      return this.$store.state.warrantyDurationConfig.totalCount;
  }
  get currentPage(){
      return this.$store.state.warrantyDurationConfig.currentPage;
  }
  columns = columns;

  async created(){
    this.getClients();
  }

  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        this.clients = this.$store.state.client.clientsForSelect;
        if (!this.isClient())
          this.pagerequest.clientCode =
            this.clients.length === 0 ? "" : this.clients[0].code;
      });
  }
}
